import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "px-3 font-bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "ANAF token", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Token:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Token refresh:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Token exp:", -1)
const _hoisted_11 = { class: "p-fluid" }
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "clientID" }, " Client ID: ", -1)
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "clientID" }, " Client Secret: ", -1)
const _hoisted_16 = { class: "p-field" }
const _hoisted_17 = { class: "p-field" }
const _hoisted_18 = { class: "p-field" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "text-center font-bold" }
const _hoisted_21 = { class: "px-3 font-bold" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", null, "Upload token", -1)
const _hoisted_23 = { class: "p-fluid" }
const _hoisted_24 = { class: "p-field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "basicDate" }, " Valid to: ", -1)
const _hoisted_26 = { class: "p-field" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "bAuthUser" }, " User: ", -1)
const _hoisted_28 = {
  id: "bAuthUser",
  class: "p-input-icon-right"
}
const _hoisted_29 = { class: "p-field" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "bAuthToken" }, " Token: ", -1)
const _hoisted_31 = {
  id: "bAuthToken",
  class: "p-input-icon-right"
}
const _hoisted_32 = { class: "p-field" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { for: "bAuthCurl" }, " CURL example: ", -1)
const _hoisted_34 = {
  id: "bAuthCurl",
  class: "p-input-icon-right"
}
const _hoisted_35 = { class: "text-center font-bold" }
const _hoisted_36 = { class: "px-3 font-bold" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h2", null, "systems@work integration", -1)
const _hoisted_38 = { class: "p-fluid" }
const _hoisted_39 = { class: "p-field" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "bAuthCurl" }, " s@w integration URL: ", -1)
const _hoisted_41 = {
  id: "bAuthCurl",
  class: "p-input-icon-right"
}
const _hoisted_42 = { class: "p-field" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "bAuthUser" }, " User: ", -1)
const _hoisted_44 = {
  id: "bAuthUser",
  class: "p-input-icon-right"
}
const _hoisted_45 = { class: "p-field" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { for: "bAuthToken" }, " Password: ", -1)
const _hoisted_47 = {
  id: "bAuthToken",
  class: "p-input-icon-right"
}

import DialogLoader from "@/components/DialogLoader.vue";
import { onMounted, ref } from "vue";
import axios from "axios";
import store from "@/store";
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSettings',
  setup(__props) {

const dayJS = dayjs;

let basicDateDefault = new Date();
basicDateDefault.setFullYear(basicDateDefault.getFullYear() + 1);

const company = ref({
  name: "",
  vat: "",
  clientid: "",
  clientsecret: "",
  anaftoken: "",
  anaftokenref: "",
  anaftokenexp: 0,
  sawurl: "",
  sawuser: "",
  sawpass: "",
});
const basicAuthDate = ref(basicDateDefault);
const basicAuth = ref({ user: "", token: "", curl: "" });
const showLoader = ref(false);

onMounted(() => {
  getCompany();
});
/*
function anafLogin() {
  window.location.href = "/api/v1/oauth2/anaf";
}
*/
function getCompany() {
  showLoader.value = true;
  axios
    .get("api/v1/company")
    .then((response) => {
      console.log("COMP: ", response.data);
      company.value = response.data;
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    })
    .finally(() => {
      showLoader.value = false;
    });
}

function updateCompany() {
  axios
    .put("api/v1/companydetails", company.value)
    .then(() => {
      getCompany();
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    });
}

function testAnafToken() {
  axios
    .get("api/v1/anaftest")
    .then((response) => {
      store.commit("setToast", {
        sev: "success",
        sum: "Response",
        det: response.data.message,
      });
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    });
}

function createBasicAuthToken() {
  let currentDate = new Date();
  // calculate the difference between the two dates in minutes
  let difference = basicAuthDate.value.getTime() - currentDate.getTime();
  let minutesDifference = Math.floor(difference / 1000 / 60);
  console.log("Minutes: ", minutesDifference);

  axios
    .post("api/v1/tokenrequest", { validity: minutesDifference })
    .then((response) => {
      basicAuth.value = response.data;
      const baseUrl = window.location.origin;
      basicAuth.value.curl = `curl -u ${response.data.user}:${response.data.token} -X POST -H "Content-Type: text/xml" -d @yourfile.xml ${baseUrl}/apip/v1/invoice`;
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    });
}

const getAnafToken = () => {
  const link = document.createElement("a");
  link.href = `/api/v1/oauth2/anaf`;
  // link.setAttribute("download", props.linkInfo?.name as string);
  document.body.appendChild(link);
  link.click();
};

function ctc(text: string) {
  navigator.clipboard.writeText(text).then(
    function () {
      store.commit("setToast", {
        sev: "success",
        sum: "Copied to clipboard",
        det: text,
      });
    },
    function (err) {
      store.commit("setToast", {
        sev: "error",
        sum: "Error",
        det: err,
      });
    }
  );
}

return (_ctx: any,_cache: any) => {
  const _component_Divider = _resolveComponent("Divider")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Password = _resolveComponent("Password")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, "Settings - " + _toDisplayString(company.value.name) + " (" + _toDisplayString(company.value.vat) + ")", 1),
      _createVNode(_component_Divider),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_Divider),
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(company.value.anaftoken) + " ", 1),
            _hoisted_7,
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(company.value.anaftokenref) + " ", 1),
            _hoisted_9,
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_unref(dayJS)(company.value.anaftokenexp * 1000).format("DD.MM.YYYY HH:mm")) + " ", 1),
            _createVNode(_component_Divider),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_InputText, {
                  id: "clientID",
                  modelValue: company.value.clientid,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((company.value.clientid) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_InputText, {
                  id: "clientID",
                  modelValue: company.value.clientsecret,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((company.value.clientsecret) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_Button, {
                  label: "Update client Settings",
                  class: "p-button-success my-2",
                  onClick: updateCompany
                })
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_Button, {
                  label: "Get ANAF token",
                  class: "p-button-success my-2",
                  onClick: getAnafToken
                })
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_Button, {
                  label: "TEST ANAF TOKEN",
                  class: "p-button-success my-2",
                  onClick: testAnafToken
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_Divider),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_Calendar, {
                    id: "basicDate",
                    modelValue: basicAuthDate.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((basicAuthDate).value = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("span", _hoisted_28, [
                    _createElementVNode("i", {
                      class: "pi pi-copy",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (ctc(basicAuth.value.user)))
                    }),
                    _createVNode(_component_InputText, {
                      modelValue: basicAuth.value.user,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((basicAuth.value.user) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("span", _hoisted_31, [
                    _createElementVNode("i", {
                      class: "pi pi-copy",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (ctc(basicAuth.value.token)))
                    }),
                    _createVNode(_component_InputText, {
                      modelValue: basicAuth.value.token,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((basicAuth.value.token) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("span", _hoisted_34, [
                    _createElementVNode("i", {
                      class: "pi pi-copy",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (ctc(basicAuth.value.curl)))
                    }),
                    _createVNode(_component_InputText, {
                      modelValue: basicAuth.value.curl,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((basicAuth.value.curl) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_component_Button, {
                  label: "Create basic Auth token",
                  class: "p-button-success my-2",
                  onClick: createBasicAuthToken
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createVNode(_component_Divider),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("span", _hoisted_41, [
                    _createVNode(_component_InputText, {
                      modelValue: company.value.sawurl,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((company.value.sawurl) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("span", _hoisted_44, [
                    _createVNode(_component_InputText, {
                      modelValue: company.value.sawuser,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((company.value.sawuser) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("span", _hoisted_47, [
                    _createVNode(_component_Password, {
                      modelValue: company.value.sawpass,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((company.value.sawpass) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_component_Button, {
                  label: "Save settings",
                  class: "p-button-success my-2",
                  onClick: updateCompany
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(DialogLoader, { showLoader: showLoader.value }, null, 8, ["showLoader"])
  ], 64))
}
}

})